import { render, staticRenderFns } from "./xfd.vue?vue&type=template&id=2c1899e8&scoped=true&"
var script = {}
import style0 from "./xfd.vue?vue&type=style&index=0&id=2c1899e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1899e8",
  null
  
)

export default component.exports